// removed by extract-text-webpack-plugin
module.exports = {"container":"manage-envelopes__container___HjnPB","title":"manage-envelopes__title___2Vd7G","actions-panel":"manage-envelopes__actions-panel___1vyZO","envelope-actions":"manage-envelopes__envelope-actions___3bY3j","grid":"manage-envelopes__grid___2WQjJ"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/manage-envelopes/manage-envelopes.scss
// module id = 1343
// module chunks = 0